<template>
    <div>
        <div class="row">
            <div class="col-8">
                <select-clients v-on:removeAllClients="removeAllClients" v-on:removeClient="removeClient"
                    v-on:addClient="addClient" :wallets="wallets" />
            </div>

            <div class="col-4">
                <preview-whatsapp :text="text" />
                <start-conversation :btnFinish="true" @started="selectedTemplate($event)" clientName="{NomeDoCliente}">
                </start-conversation>
            </div>
        </div>

        <hr>

        <div class="sub-campaign">
            <input type="text" class="form-control" placeholder="Nome da Campanha" v-model="campaignName">
            <b-button @click="submitCampaign" class="submit-button">
                Enviar <i class="fas fa-paper-plane"></i>
            </b-button>
        </div>
    </div>
</template>

<script>
import PreviewWhatsapp from './PreviewWhatsapp.vue';
import SelectClients from './SelectClientes.vue';
import MessageText from './MessageText.vue';
import StartConversation from '../newScreen/mensagem/StartConversation.vue';
import { mapActions } from 'vuex';

export default {
    props: {
        wallets: {
            type: Array,
            default: () => []
        }
    },
    components: {
        PreviewWhatsapp,
        SelectClients,
        MessageText,
        StartConversation
    },
    data() {
        return {
            text: [],
            selectedTemplates: [],
            clients: [],
            controlMsgs: 1,
            campaignName: '',
        }
    },
    methods: {
        ...mapActions(["sendCampaign"]),
        addClient(client) {
            this.clients.push(client);
        },
        removeClient(client) {
            this.clients = this.clients.filter(el => {
                if (el.name != client.name && el.phone != client.phone) return el;
            });
            if (this.clients == undefined) this.clients = [];
        },
        removeAllClients() {
            this.clients = [];
        },
        submitCampaign() {
            if (!this.clients.length) {
                Swal.fire({
                    type: 'error',
                    title: 'Nenhum contato selecionado!',
                    text: "Selecione pelo menos 1 contato para iniciar a campanha!"
                });
                return;
            }

            if (!this.selectedTemplates.length) {
                Swal.fire({
                    type: 'error',
                    title: 'Nenhum template selecionado!',
                    text: "Selecione pelo menos 1 template para iniciar a campanha!"
                });
                return;
            }

            const id = Date.now();
            if (!this.campaignName) {
                this.campaignName = `campanha-${id}`;
            }

            this.clients.forEach(el => {
                el.id = id;
                el.campaignName = this.campaignName;
            });

            const obj = {
                templates: this.selectedTemplates,
                clients: this.clients.map(clts => {
                    let formatPhone = `${clts.phone}@s.whatsapp.net`;
                    if (formatPhone.slice(0, 2) !== "55") {
                        formatPhone = `55${formatPhone}`;
                    }

                    return {
                        name: clts.name,
                        phone: formatPhone
                    }
                }),
            }

            axios.post('/marketing/addCampaign', this.clients)
                .then(() => {
                    this.sendCampaign(obj);
                    Swal.fire(
                        `Campanha "${this.campaignName}" iniciada.`,
                        'Os clientes selecionados iram receber as mensagens em breve.',
                        'success'
                    ).then(() => {
                        location.reload();
                    });

                    this.campaignName = '';
                    this.clients = [];
                    this.selectedTemplates = [];
                    this.text = [];
                });
        },
        selectedTemplate(template) {
            this.text.push(template.text);
            this.selectedTemplates.push(template);
        },
    },
}
</script>

<style scoped>
#msg-text-slot {
    max-height: 25vh;
    overflow-y: auto;
}

.col {
    padding-right: 0;
    padding-left: 0;
}

.d-flex {
    margin-top: 40px;
    flex-direction: column;
}

.submit-form-container {
    margin-top: 12px;
}

.submit-button {
    color: #fff;
    background: #25d366;
    width: 180px;
    border: none;
    font-weight: bold;
    border-radius: 10px !important;
}

.submit-button:hover {
    background: #157237;
}

.action-buttons {
    margin: 10px 0px;
    text-align: center;
}

#add-button {
    color: #635994;
    font-weight: bold;
    font-size: 14px;
    background-color: white;
    border-radius: 10px !important;
    border: 3px solid #635994;
    padding-left: 2px;
    padding-right: 2px;
}

#add-button:hover {
    color: white;
    border: 3px solid #635994;
    background-color: #8f81d3b7;
}

#del-button {
    color: #f92f60;
    font-weight: bold;
    font-size: 14px;
    background-color: white;
    border-radius: 10px !important;
    border: 3px solid #f92f60;
    padding-left: 2px;
    padding-right: 2px;
}

#del-button:hover {
    color: white;
    border: 3px solid #f92f60;
    background-color: #f92f617e;
}

.sub-campaign {
    display: flex;
    justify-content: space-between;
}

.sub-campaign>input {
    width: 60%;
}
</style>